import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Necesito herramientas caras para usar esto?',
  answer: 'No, todo se puede hacer con las herramientas gratuitas dentro de la App de Airbnb. No necesitas suscripciones adicionales ni software de terceros.'
}, {
  question: '¿Funciona para VRBO o Booking?',
  answer: 'Sí, las plantillas son universales para cualquier plataforma de renta corta. El sistema está diseñado para adaptarse a Airbnb, VRBO, Booking.com y cualquier otra plataforma que uses.'
}, {
  question: '¿Qué pasa si mi huésped no habla español?',
  answer: 'El sistema está en español para que tú lo gestiones, pero incluimos la lógica para que puedas traducirlo fácilmente si recibes público angloparlante. La estructura y el timing de los mensajes funcionan en cualquier idioma.'
}, {
  question: '¿Cuánto tiempo tarda la configuración inicial?',
  answer: 'Menos de 10 minutos. Incluimos una guía paso a paso específicamente para la App de Airbnb. Si ya tienes tus fotos de la propiedad listas, puedes tenerlo todo configurado en una sola sesión.'
}, {
  question: '¿Qué pasa si no estoy satisfecho?',
  answer: 'El sistema es tan específico y accionable que confiamos en que lo implementarás y verás resultados desde la primera semana. Si tienes dudas sobre si es para ti, revisa la sección "¿Esto es para ti?" más arriba.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-20 px-6" style={{
    backgroundColor: '#F5F0EB'
  }} data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-41">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase mb-4" style={{
          color: '#FF5A5F',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-42">
            Preguntas frecuentes
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold leading-tight" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-43">
            Resolvemos tus dudas
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3" data-id="element-44">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-[#E8E0D8] overflow-hidden shadow-sm" data-id="element-45">
              <button className="w-full flex items-center justify-between gap-4 p-6 text-left transition-colors duration-150" onClick={() => toggle(index)} aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} id={`faq-question-${index}`} style={{
            backgroundColor: openIndex === index ? '#FFF5F5' : 'white'
          }} data-id="element-46">
                <span className="text-base font-semibold leading-snug" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-47">
                  {faq.question}
                </span>
                <ChevronDownIcon className="flex-shrink-0 w-5 h-5 transition-transform duration-200" style={{
              color: '#FF5A5F',
              transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)'
            }} aria-hidden="true" data-id="element-48" />
              </button>
              {openIndex === index && <div id={`faq-answer-${index}`} role="region" aria-labelledby={`faq-question-${index}`} className="px-6 pb-6" data-id="element-49">
                  <p className="text-base leading-relaxed" style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-50">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}